export default __webpack_public_path__ + "static/media/17.4b5ea76e.png";